(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/helpers/handlebars-helpers.js');
"use strict";


(function () {
  'use strict';

  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('getLBSite', () => {
      const domain = "//".concat(window.location.hostname);
      if (domain.indexOf('spela') > 0) {
        return domain;
      } else if (domain.indexOf('www') > 0) {
        return domain.replace('www', 'spela');
      }
      return domain.replace('tur', 'spela');
    });
    hbs.registerHelper('cdnContent', url => svs.core.config.data.svsconfig.cdn2 + url);
    hbs.registerHelper('isDateNOTBetween', function (firstDate, lastDate, options) {
      const today = new Date();
      const result = !(today > new Date(firstDate) && today < new Date(lastDate));
      if (result) {
        return options.fn(this);
      }
      return options.inverse(this);
    });
    hbs.registerHelper('paymentDate', paymentDate => {
      const today = new Date();
      const payDate = new Date(paymentDate);
      let monthsToPayDate;
      let paymentDateString = '';
      if (dateFns && today < payDate) {
        monthsToPayDate = (payDate.getYear() - today.getYear()) * 12 + payDate.getMonth() - today.getMonth();
        if (monthsToPayDate < 3) {
          paymentDateString = "Resultatet av \xE5rets utdelning presenteras den ".concat(dateFns.format(payDate, 'd MMMM'));
        } else {
          paymentDateString = "N\xE4sta utbetalning redovisas i ".concat(dateFns.format(payDate, 'MMMM yyyy'));
        }
      }
      return paymentDateString;
    });

    Handlebars.registerHelper('eachSort', function () {
      const values = Array.prototype.slice.call(arguments, 0);
      let list = [];
      let sortKey = '';
      let maxLength = 0;
      let descending = false;
      let options = {};

      for (let i = 0; i < values.length; i++) {
        if (_.isArray(values[i])) {
          list = values[i];
        } else if (_.isString(values[i])) {
          sortKey = values[i];
        } else if (_.isNumber(values[i])) {
          maxLength = values[i];
        } else if (_.isBoolean(values[i])) {
          descending = values[i];
        } else if (_.isObject(values[i])) {
          options = values[i];
        }
      }
      let sorted = list;
      if (sortKey) {
        sorted = _.sortBy(list, item => item[sortKey]);
      }
      if (descending) {
        sorted = sorted.reverse();
      }
      if (maxLength > 0) {
        sorted = sorted.slice(0, maxLength);
      }
      return Handlebars.helpers.each(sorted, options);
    });
  }
})();

 })(window);